<p-toast position="top-right" [baseZIndex]="12000"></p-toast>
<div>
  <div style="position:fixed;left:0;bottom:0;width:100%;background:#eee;color:#333;padding:4px 8px;font-size:12px;z-index:9999;text-align:left;border-top:1px solid #ccc">
    Version: {{ version }}
  </div>
  <router-outlet></router-outlet>
  <p-blockui   [blocked]="loading$ | async" >
    <ng-template pTemplate="content">
      <div class="global-loader">
        <div class="loader">
          <p-progress-spinner ariaLabel="loading"></p-progress-spinner>
          <p>{{ (label$ | async) || 'Attendere…' }}</p>
        </div>
      </div>
    </ng-template>
  </p-blockui>

</div>
